import "./promotions.css";
import React, { useEffect } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Drawer from "@mui/material/Drawer";
import CancelIcon from "@mui/icons-material/Cancel";

const Promotions = (props) => {
  const [promotions, setPromotions] = React.useState(null);
  const [showDrawer, setShowDrawer] = React.useState(false);
  const [currentIndex, setCurrentIndex] = React.useState(0);

  useEffect(() => {
    setPromotions(props.data.promotions.items);

    props.data.categories.items.map((v) => ({ ...v, isActive: false }));
    props.data.categories.items[0].isActive = true;
  }, [props.data]);

  const loadCategory = (idcategory) => {
    console.log(idcategory);
    var filtered = [];

    if (idcategory === "all") {
      filtered = props.data.promotions.items;
    } else {
      props.data.promotions.items.forEach((element) => {
        if (element.category === idcategory) {
          filtered.push(element);
        }
      });
    }

    setPromotions(filtered);

    console.log("filtered", filtered);

    props.data.categories.items.forEach((element) => {
      element.isActive = false;
      if (element.id === idcategory) {
        element.isActive = true;
      }
    });
  };

  const toggleDrawer = (open, index) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    console.log("index", index);
    setCurrentIndex(index);
    setShowDrawer(open);
  };

  return (
    <div className="container promotions-container pt-4 pb-4">
      {/* Hellow from promotions */}
      <div className="prom-title  d-flex justify-content-center">
        {documentToReactComponents(props.data.title.json)}
      </div>

      <div className="row pt-4   d-flex justify-content-center">
        {/* {props.data.categories.items.map((item, index)=>{
                    return(
                      <div  key={index} className="col-category ">
                        <div style={{cursor:'pointer'}} onClick={()=>{loadCategory(item.id)}}>
                        <div className="cont-dot d-flex justify-content-center">
                            <div  className={item.isActive ? "dot-category-active d-flex justify-content-center align-items-center" : "dot-category d-flex justify-content-center align-items-center"}>
                                <img  className="col-6 icon-category" src={item.icon} alt={item.icon} />
                            </div> 
                        </div>
                        <div>{item.title}</div>
                        </div>
                      </div>
                    )
                })} */}
      </div>
      <div className="promo-container row  pb-4 ">
        {promotions !== null &&
          promotions.map((item, index) => {
            return (
              <div
                key={index}
                id={"item-promo-" + index}
                data-promo={item.title + " - " + item.establishment}
                className="item-prom  col-12  col-md-4  p-3  "
              >
                <div
                  onClick={toggleDrawer(true, index)}
                  className="item-prom-shadow  "
                >
                  <div className="row  h-100  no-padding ">
                    <div
                      className="col-4  img-promo "
                      style={{ backgroundImage: `url(${item.image})` }}
                    ></div>
                    <div className="col-8  pt-1 prom-data ">
                      <div className="title-promo-item">
                        <b>{item.title}</b>
                      </div>
                      <div className="establishment  ">
                        {item.establishment}
                      </div>
                      <div className="row no-padding">
                        <div className=" col-percent ">
                          <b>{item.percent}</b>
                        </div>
                        {item.days.map((day, i) => {
                          return (
                            <div className=" col-day p-1 " key={i}>
                              {day}
                            </div>
                          );
                        })}
                      </div>
                      <br />
                      <div className="pt-1 expire-cont">
                        <span style={{ fontSize: "small" }}>vigencia</span>{" "}
                        <span className="expired-label">{item.expire}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        {promotions !== null && promotions.length >= 1 && (
          <div className="container d-flex justify-content-center">
            <a
              href={"/" + props.keyCountry + "/promotions-" + props.keyCountry}
            >
              <button className="btn-benefit">VER MÁS</button>
            </a>
          </div>
        )}
      </div>

      <div className="pb-4">
        <div>
          {
            <React.Fragment key="right">
              {/* <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
              <Drawer
                anchor="right"
                open={showDrawer}
                onClose={toggleDrawer(false)}
              >
                <div className="draw-container ">
                  <div className="img-drawer-container ">
                    <CancelIcon
                      onClick={toggleDrawer(false)}
                      fontSize="large"
                      sx={{ color: "#FFF" }}
                      style={{
                        position: "absolute",
                        top: "10px",
                        left: "10px",
                        cursor: "pointer",
                      }}
                    />
                    <img
                      className="img-drawer img-fluid"
                      src={
                        promotions !== null && promotions[currentIndex]?.image
                      }
                      alt="alt"
                    />
                  </div>

                  <div className="main-info-container w-100   p-4">
                    <div className="w-100 p-2  drawer-shadown-conatiner">
                      <h2>
                        <small>
                          {promotions !== null &&
                            promotions[currentIndex]?.establishment}
                        </small>{" "}
                      </h2>
                      <h2>
                        <b>
                          {promotions !== null &&
                            promotions[currentIndex]?.percent}
                        </b>
                      </h2>
                      <h2>
                        {" "}
                        {promotions !== null &&
                          currentIndex !== undefined &&
                          promotions[currentIndex]?.title}{" "}
                      </h2>
                    </div>

                    <div className="w-100  pt-4  ">
                      <p className="">
                        {promotions !== null &&
                          promotions[currentIndex]?.description}
                      </p>
                    </div>

                    <hr />

                    <div className="w-100 p-2  days-drawer-container ">
                      <h3>Cuándo usarlo</h3>
                      <div className="row">
                        {promotions !== null &&
                          promotions[currentIndex]?.days.map((day, index) => {
                            return (
                              <div key={index} className="item-drawer-day">
                                {day}
                              </div>
                            );
                          })}
                      </div>
                    </div>

                    <hr />
                    <div className="expire-container p-2">
                      <p className="pt-2">Vigencia: &nbsp;</p>
                      <h3>
                        <b>
                          {promotions !== null &&
                            promotions[currentIndex]?.expire}
                        </b>
                      </h3>
                    </div>

                    <hr />
                    <div className="expire-container p-2">
                      <p className="pt-2">Ubicación: &nbsp;</p>
                      <h3>
                        <b>
                          {promotions !== null &&
                            promotions[currentIndex]?.address}
                        </b>
                      </h3>
                    </div>

                    <hr />

                    <div className="legals ">
                      <h3>Legales</h3>

                      <p className="">
                        <small
                          dangerouslySetInnerHTML={{
                            __html: String(
                              promotions !== null &&
                                promotions[currentIndex]?.legals
                            ),
                          }}
                        >
                          {/* {promotions !== null && promotions[currentIndex]?.legals} */}
                        </small>
                      </p>
                    </div>
                  </div>
                </div>
              </Drawer>
            </React.Fragment>
          }
        </div>
      </div>
    </div>
  );
};

export default Promotions;
